// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__37NK8","header":"ClearentDisclaimer_header__2UK9D","inner":"ClearentDisclaimer_inner__1Kis-"};